module.exports = __webpack_public_path__ + "img/add.fb98d590.svg";